import { PageControl } from './main';

export class CitiesAmountHelper {
  globalCities: number;
  brazilianCities: number;
  totalCities: Number = 0;
}

export class SmartCitiesHelper {
  id: string;
  name: string;
  region: string;
  country: string;
  slug: string;
}

export class HighlightedCitiesHelper {
  cityId: string;
  name: string;
  region: string;
  country: string;
  image: string;
  areaName: string;
  areaIcon: string;
  areaScore: number;
  slug: string;
}

export class CityProfile {
  id: string;
  name: string;
  region: string;
  country: string;
  populationTotal: number;
  populationRange: 'POPULATION_RANGE_1' | 'POPULATION_RANGE_2' | 'POPULATION_RANGE_3' | 'POPULATION_RANGE_4' | 'POPULATION_RANGE_5';
  landArea: number;
  populationDensity: number;
  countryGrossDomesticProduct: number;
  cityGrossOperatingBudget: number;
  cityGrossCapitalBudget: number;
  percentPopulationYouthAged: number;
  percentPopulationSeniorAged: number;
  householdTotal: number;
  householdIncomeAverage: number;
  cityProductPerCapita: number;
  annualInflationRate: number;
  unemployementRate: number;
  populationPovertyPercetage: number;
  indicators: IndicatorHelper[];
  isActive: boolean;
  image: string;
  cityGrossDomesticProduct: number;
  percentProfileCompleted: number;
  percentIndicatorCompleted: number;
  indicatorsPercentage: number;
  indicatorsAmount: number;
  globalRank: number;
  cityScore: number;
  tableauItemName: string;
  tableauEmbedCode: string;
  powerBIEmbedCode: string;
}

export class IndicatorHelper {
  name: string;
  description: string;
  icon: string;
  score: number;
  cityBenchmarkName: string;
  cityBenchmarkRegion: string;
  cityBenchmarkCountry: string;
  cityBenchmarkId: string;
  cityBenchMarkScore: number;
  areaIcon: string;
  areaId: string;
  areaName: string;
  indicatorId: string;
  indicatorName: string;
  areas: string[] = [];
  insufficientData: string;
  indicatorsPercentage: number;
}
export class ProfileHelper {
  name: string;
  description: string;
}
export class InterestedUser {
  name: string;
  email: string;
}

export class SolutionPerCityIndicator {
  areaId: string;
  areaName: string;
  areaIcon: string;
  indicatorId: string;
  indicatorName: string;
  solutionId: string;
  benchmarkCityName: string;
  benchmarkGap: number;
  positionToday: number;
  estimatedPosition5Years: number;
}

export class GlobalBenchmarkCity {
  areaId: string;
  areaName: string;
  score: number;
  cityId: string;
  name: string;
  region: string;
  country: string;
  slug: string;
}

export class CityProfileIndicatorsHelper {
  id: string;
  name: string;
  region: string;
  country: string;
  areaScores: CityProfileAreaScoreHelper[];
  slug: string;
}

// Indicador header score
export class CityProfileAreaScoreHelper {
  areaId: string;
  name: string;
  description: string;
  icon: string;
  areaScore: number;
  bechmarkScore: number;
  areaBenchmarkCity: SmartCitiesHelper;
  indicatorScores: CityIndicatorScoreHelper[];
}

// lista do profile
export class CityIndicatorScoreHelper {
  indicatorId: string;
  indicatorName: string;
  indicatorScore: number;
  bechmarkScore: number;
  indicatorBenchmarkCity: SmartCitiesHelper;
}

export class SolutionPerCityIndicatorHeaderHelper {
  cityId: string;
  cityName: string;
  cityRegion: string;
  cityCountry: string;
  slug: string;
  effect: BestSolutionPerCityIndicatorHelper;
}

export class BestSolutionPerCityIndicatorHelper {
  areaId: string;
  areaName: string;
  areaIcon: string;
  indicatorId: string;
  indicatorName: string;
  solutionId: string;
  benchmarkCityName: string;
  benchmarkGap: number;
  positionToday: number;
  estimatedPosition5Years: number;
  impact: number;
}
export class UserUpdateRequest {
  cityProfile: CityProfileAdmin;
  indicators: IndicatorRequestUpdateHelper[];
}

export class IndicatorRequestUpdateHelper {
  indicatorScoreId: string;
  value: number;
}

export class AddedProfileHelper {
  cityProfile: CityProfileAdmin;
  userCityProfile: CityProfileAdmin;
  indicators: IndicatorUpdateHelper[];
}

export class IndicatorUpdateHelper {
  name: string;
  areaId: string;
  indicatorId: string;
  indicatorScoreId: string;
  score: number;
  userScore: number;
  normalizedScore: number;
}

export class IndicatorScoreUpdateAdminHelper {
  name: string;
  areaId: string;
  indicatorId: string;
  indicatorScoreId: string;
  score: number;
  userScore: number;
  normalizedScore: number;
}

export class DefaultStatus {
  success: boolean;
}

export class CityProfileAdmin {
  id: string;
  cityId: string;
  cityGrossDomesticProduct: number;
  totalPopulation: number;
  landArea: number;
  populationDensity: number;
  countryGrossDomesticProduct: number;
  cityGrossOperatingBudget: number;
  cityGrossCapitalBudget: number;
  percentageOfCountryPopulation: number;
  percentOfPopulationYouthAged15_24: number;
  percentOfPopulationSeniorAgedOver65: number;
  annualPopulationChange: number;
  percentOfPopulationForeignBorn: number;
  percentOfPopulationNewImmigrants: number;
  percentOfPopulationChildrenAged0To14: number;
  percentOfPopulationAdultAged25To64: number;
  maleToFemalRatio: number;
  populationDependencyRatio: number;
  percentOfPopulationNonCitizens: number;
  totalNumberOfHouseholds: number;
  personsPerUnit: number;
  totalNumberOfOccupiedDwellingUnits: number;
  dwellingDensity: number;
  averageHouseholdIncome: number;
  cityProductPerCapita: number;
  cityProductAsPercentOfCountryGDP: number;
  employmentAnnualPercentChange: number;
  annualInflationRate: number;
  giniCoefficient: number;
  countryGDPPerCapita: number;
  scores: any = []; // tratar como any e inicializar como = []
  generalScore: number;
}

export class IndicatorAdminHelper {
  areaId: string;
  areaName: string;
  areaIcon: string;
  indicatorId: string;
  indicatorName: string;
}

export class Area {
  id: string;
  icon: string;
  name: string;
  description: string;
}

export class Link {
  id: string;
  status: string;
  cityId: string;
  sendDate: string;
  publishDate: string;
  creationDate: string;
  cityProfile: CityProfileAdmin;
  indicators: IndicatorRequestUpdateHelper[];
}

export class IndicatorValidationHelper {
  indicatorId: string;
  type: string;
}

export class CityLinksListPage {
  data: CityLinkListHelper[];
  count: number;
  page: number;
  maxPage: number;
}

export class CityLinkListHelper {
  city: SmartCitiesHelper;
  links: LinkListHelper[];
}

export class LinkListHelper {
  id: string;
  creationDate: Date;
  sendDate: Date;
  publishDate: Date;
  status: string;
}

export class LinkFilterHelper {
  search: string;
  page: number;
  limit: number;
  orderByField: string;
  orderDirection: string;
}

// Painel
export class CitiesSearchParams {
  areas: string[] = [];
  population: string[] = [];
  location: string[] = [];
  sort: string;
  limit: Number = 10;
  page: Number = 0;
  findCity: string;
  order: string;
  pageControl: PageControl = new PageControl();
}

export class CitiesInfo {
  basicInfo: CitiesInfoBasic = new CitiesInfoBasic();
  profile: CitiesInfoProfile = new CitiesInfoProfile();
  profileHistory: CityProfileHistory = new CityProfileHistory();
}

export class CitiesInfoBasic {
  continent: string;
  country: string;
  googleMapsName: string;
  id: string;
  image: string;
  isSmartCity2025: boolean;
  tableauItemName: string;
  tableauEmbedCode: string;
  powerBIEmbedCode: string;
  name: string;
  region: string;
  pinPointCoordinates: number[] = [0, 0];
  certificationIds: string[];
  cnpj: string;
}

export class CitiesInfoProfile {
  annualInflationRate: number;
  annualPopulationChange: number;
  averageHouseholdIncome: number;
  cityGrossCapitalBudget: number;
  cityGrossDomesticProduct: number;
  cityGrossOperatingBudget: number;
  cityId: string;
  cityProductAsPercentOfCountryGDP: number;
  cityProductPerCapita: number;
  countryGDPPerCapita: number;
  countryGrossDomesticProduct: number;
  dwellingDensity: number;
  employmentAnnualPercentChange: number;
  generalScore: number;
  giniCoefficient: number;
  id: string;
  landArea: number;
  maleToFemalRatio: number;
  percentOfPopulationAdultAged25To64: number;
  percentOfPopulationChildrenAged0To14: number;
  percentOfPopulationForeignBorn: number;
  percentOfPopulationNewImmigrants: number;
  percentOfPopulationNonCitizens: number;
  percentOfPopulationSeniorAgedOver65: number;
  percentOfPopulationYouthAged15_24: number;
  percentageOfCountryPopulation: number;
  personsPerUnit: number;
  populationDensity: number;
  populationDependencyRatio: number;
  populationPovertyPercentage: number;
  totalNumberOfHouseholds: number;
  totalNumberOfOccupiedDwellingUnits: number;
  totalPopulation: number;
  unemploymentRate: number;
  scores: IndicatorUpdateHelper[] = [];
}

export class CityProfileHistory {
  cityId: string;
  profiles: CityProfileYear[] = [];
}

export class CityDataInfo {
  dataSourceId: string;
  paramId: string;
  value: number;
}

export class CityProfileYear {
  profile: CityDataInfo[] = [];
  year: number;
}

export class CityDataSource {
  id: string;
  name: string;
}

export class IndicatorSearchFilter {
  areas: string[] = [];
  purposes: string[] = [];
  influencesScore: boolean;
  pageControl: PageControl = new PageControl();
  searchQuery: string;
}

export class CityIndicatorScore {
  areas: string[] = [];
  cityId: string;
  id: string;
  indicatorId: string;
  normalizedScore: number;
  score: number;
}

export interface MyCityInfo {
  id: string;
  name: string;
  country: string;
  region: string;
}
